import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import styles from './Alert.module.css';

export type AlertVariant = 'success' | 'warning' | 'error' | 'info';

export type AlertProps = {
  variant?: AlertVariant;
  title?: string;
  children: ReactNode;
  onClose?: () => void;
};

export function Alert({ variant = 'info', title, children, onClose }: AlertProps) {
  return (
    <div className={`${styles.alert} ${styles[variant]}`} role="alert">
      <div className={styles.content}>
        {title ? <strong className={styles.title}>{title}</strong> : null}
        <div>{children}</div>
      </div>
      {onClose ? (
        <button type="button" className={styles.close} onClick={onClose} aria-label="Fechar">
          <X size={16} />
        </button>
      ) : null}
    </div>
  );
}
